<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 class="px-3 py-0">
        <v-card class="pa-3">
          <v-flex xs12 class="pl-3 pr-0 py-0">
            <v-card-actions class="mr-0 mb-3"
              ><v-spacer></v-spacer>
              <v-btn dark color="default" @click="cancel">Cancel</v-btn>
              <v-btn color="success" @click="sendMessage">Send</v-btn>
            </v-card-actions>
          </v-flex>
          <v-layout row>
            <v-flex xs6 class="pr-2 pl-3 pb-0 xs4 pt-0">
              <v-autocomplete
                class="mb-4 pt-0"
                hide-details
                label="From Number"
                hide-no-data
                ref="from"
                v-model="from"
                item-text="displayNumber"
                :items="fromNumbers"
                :search-input.sync="loadPhoneNumbers"
                :loading="loadingNumbers"
                return-object
                :rules="[rules.required]"
              ></v-autocomplete>
              <v-textarea
                solo
                rows="35"
                label="Message"
                v-model="message"
                ref="message"
                :rules="[rules.required]"
              ></v-textarea>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex
              xs6
              class="px-2 pb-0 xs4 pt-0 scroll"
              style="height: calc(100vh - 170px);"
            >
              <v-layout row class="mt-3">
                <v-layout column class="pl-3" style="width: 46%;">
                  <div class="subheading font-weight-medium mb-2">
                    Instructions
                  </div>
                  <ul class="body-1">
                    <li>File should be in CSV format.</li>
                    <li>
                      Column Configration: A. Account ID (Optional), B. Phone
                      Number (Required), C. Phone Number (Optional), D. Phone
                      Number (Optional), E. Phone Number (Optional)
                    </li>
                  </ul>
                </v-layout>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  style="height: 34px;"
                  color="success"
                  class="white--text mr-2 mt-0"
                  @click="openManualInputDialog()"
                >
                  <v-icon left dark>mdi-plus</v-icon>
                  Add Manually
                </v-btn>
                <v-btn
                  small
                  style="width: 150px; height: 34px;"
                  color="blue-grey"
                  class="white--text mr-3 mt-0"
                  :loading="uploading"
                  @click="pickFile()"
                >
                  <v-icon left dark>mdi-cloud-upload</v-icon>
                  Upload Numbers
                </v-btn>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept=".csv"
                  @input="onFilePicked($event)"
                  onclick="this.value = null"
                />
              </v-layout>
              <v-divider class="mt-2"></v-divider>
              <vue-good-table
                v-if="to.length"
                class="number-list"
                :columns="toNumbersColumns"
                :rows="toNumbers"
                :search-options="{
                  enabled: false,
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <v-layout column class="ma-0 pa-0">
                    <span>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                    <span
                      class="text-danger pa-0 ma-0"
                      style="font-size: 11px;"
                      v-if="getError(props.row, props.column.field)"
                    >
                      {{ getError(props.row, props.column.field) }}
                    </span>
                  </v-layout>
                </template>
              </vue-good-table>
              <div v-if="!to.length && !uploading">
                <v-container fluid grid-list-md>
                  <v-layout
                    align-center
                    justify-center
                    row
                    fill-height
                    class="layout font-weight-light display-2 text--disabled mt-5 text-xs-center"
                  >
                    Please upload a list of phone numbers</v-layout
                  >
                </v-container>
              </div>
              <div v-if="uploading">
                <v-container fluid grid-list-md>
                  <v-layout
                    align-center
                    justify-center
                    row
                    fill-height
                    class="mt-5 text-xs-center"
                  >
                    <v-progress-circular
                      :size="100"
                      :width="3"
                      color="rgba(0,0,0,.38)"
                      indeterminate
                    ></v-progress-circular>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="confirmDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline">Confirm Message</v-card-title>
        <v-card-text class="mb-2">
          {{ this.message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            :disabled="sending"
            dark
            @click="confirmDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="sending" color="success" @click="process()"
            >Send</v-btn
          >
        </v-card-actions>
        <div class="font-weight-light text-xs-center" style="color: #00d3ee">
          {{ processingMessages }}
        </div>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="confirmDuplicatesDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline text-warning"
          >Duplicate Messages</v-card-title
        >
        <v-card-text class="pt-0">
          <div class="font-weight-medium mb-3" v-if="from.number">
            A message with the same text was already sent today from
            {{ formatPhoneNumber(from.number.substring(1)) }} to some of the
            numbers
          </div>

          <v-layout row class="mb-3"
            ><div class="font-weight-medium mr-1">
              Total Duplicates Found:
            </div>
            <div>{{ duplicateCount }}</div>
          </v-layout>

          <div class="font-weight-medium mr-1 mb-1" v-if="duplicateCount > 5">
            The first 5 Recipient Numbers:
          </div>
          <div v-if="duplicateCount < 6" class="font-weight-medium mr-1 mb-1">
            Recipient Numbers:
          </div>
          <div v-for="duplicate in duplicates">
            {{ formatPhoneNumber(duplicate.to) }}
          </div>
          <div class="headline text-warning mt-3">
            Still want to proceed?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            :disabled="sending"
            dark
            @click="
              confirmDuplicatesDialog = false;
              confirmDialog = false;
            "
            >Cancel</v-btn
          >
          <v-btn :loading="sending" color="success" @click="send()"
            >proceed</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="manualInputDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline px-0 pt-0 pb-2"
          >Add Phone Numbers Manually</v-card-title
        >

        <v-text-field
          label="Account ID (Optional)"
          v-model="manualEntry.accountID"
          outlined
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 1 (Required)"
          v-model="manualEntry.phone1"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.required, rules.phoneNumber]"
          ref="manualPhone1"
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 2"
          v-model="manualEntry.phone2"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.phoneNumber]"
          ref="manualPhone2"
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 3"
          v-model="manualEntry.phone3"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.phoneNumber]"
          ref="manualPhone3"
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 4"
          v-model="manualEntry.phone4"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.phoneNumber]"
          ref="manualPhone4"
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 5"
          v-model="manualEntry.phone5"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.phoneNumber]"
          ref="manualPhone5"
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Phone Number 6"
          v-model="manualEntry.phone6"
          outlined
          placeholder="123-456-7890"
          :rules="[rules.phoneNumber]"
          ref="manualPhone6"
        ></v-text-field>
        <v-card-actions class="pb-0 mr-1">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeManualInputDialog()"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="addManualEntry()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import Papa from "papaparse";
import axios from "axios";
import ky from "ky";
import Pusher from "pusher-js";

import {
  getDomain,
  formatPhoneNumber,
  onlyUnique,
  groupBy,
} from "../../utils/helpers.js";

export default {
  data: () => ({
    from: "",
    to: [],
    message: "",
    fromNumbers: [],

    uploading: false,
    sending: false,

    confirmDialog: false,
    confirmDuplicatesDialog: false,
    manualInputDialog: false,

    loadPhoneNumbers: null,
    loadingNumbers: false,

    requestID: "",
    processingMessages: "",
    totalProcessingMessages: "",

    duplicates: [],
    duplicateCount: 0,

    manualEntry: {
      accountID: "",
      phone1: "",
      phone2: "",
      phone3: "",
      phone4: "",
      phone5: "",
      phone6: "",
    },

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (value) => {
        if (!value) return true; // Optional fields
        const cleaned = value.replace(/[-() ]/g, "");
        if (!/^\d+$/.test(cleaned)) {
          return "Must be only digits";
        }
        if (cleaned.length < 10) {
          return "Must be at least 10 digits";
        }
        return true;
      },
    },

    toNumbers: [],

    toNumbersColumns: [
      {
        sortable: false,
        label: "Account ID",
        field: "accountID",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 1",
        field: "phone1",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 2",
        field: "phone2",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 3",
        field: "phone3",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 4",
        field: "phone4",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 5",
        field: "phone5",
        width: "125px",
      },
      {
        sortable: false,
        label: "Phone 6",
        field: "phone6",
        width: "125px",
      },
    ],
  }),
  watch: {
    async loadPhoneNumbers(value) {
      await this.loadNumbers();
    },
  },
  created() {
    this.loadNumbers();

    this.subscribeToPusher();
  },
  beforeDestroy() {
    this.pusher.unsubscribe("broadcast");
  },
  computed: {},
  methods: {
    subscribeToPusher() {
      this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
        cluster: "mt1",
      });

      var channel = this.pusher.subscribe("broadcast");

      this.pusher.connection.bind("error", function(err) {
        console.log(err);
      });

      channel.bind("send-sms", (message) => {
        this.updateProcessingMessages(message);
      });
    },
    updateProcessingMessages(message) {
      if (message.requestID != this.requestID) return;

      this.processingMessages =
        message.index + "/" + this.totalProcessingMessages + " " + message.text;
    },
    async loadNumbers(value = null) {
      this.loadingNumbers = true;

      const filter = value
        ? `$filter=contains(number, '${value}') or contains(description, '${value}')`
        : "";

      const url = getDomain() + `/odata/broadcast?${filter}`;

      const response = await this.$http.get(url);

      this.loadingNumbers = false;

      this.fromNumbers = response.value.map((number) => {
        number.displayNumber = `${this.formatPhoneNumber(number.number)} (${
          number.description
        } - ${number.emails})`;

        return number;
      });
    },
    pickFile(transaction) {
      this.$refs.file.click();
    },
    async onFilePicked(e) {
      if (!e.target.files) return;

      this.uploading = true;

      this.fileReader(e.target.files[0]);
    },
    fileReader(file) {
      Papa.parse(file, {
        complete: (data) => this.fileParser(data),
      });
    },
    fileParser(file) {
      if (!file.data || !file.data.length) {
        this.$notify({
          text: "No numbers found",
          group: "notification",
          type: "error",
        });

        this.uploading = false;

        return;
      }

      const numbers = this.mapPhoneNumbers(file.data);

      this.handleDuplicates(numbers);

      if (numbers.length) {
        this.to = numbers;

        const group = groupBy(numbers, "lineNumber");

        this.toNumbers = Object.keys(group).map((key) => {
          const numbers = group[key];

          return {
            accountID: numbers[0] ? numbers[0].accountID : "",
            phone1: numbers[0] ? numbers[0].number : "",
            phone2: numbers[1] ? numbers[1].number : "",
            phone3: numbers[2] ? numbers[2].number : "",
            phone4: numbers[3] ? numbers[3].number : "",
            phone5: numbers[4] ? numbers[4].number : "",
            phone6: numbers[5] ? numbers[5].number : "",
            error1: numbers[0] ? numbers[0].error : "",
            error2: numbers[1] ? numbers[1].error : "",
            error3: numbers[2] ? numbers[2].error : "",
            error4: numbers[3] ? numbers[3].error : "",
            error5: numbers[4] ? numbers[4].error : "",
            error6: numbers[5] ? numbers[5].error : "",
          };
        });

        this.uploading = false;

        return;
      }

      this.$notify({
        text: "Please upload a file with valid phone numbers",
        group: "notification",
        type: "error",
      });

      this.uploading = false;
    },
    mapPhoneNumbers(data) {
      const lines = data
        .filter((line) => line.some(Boolean))
        .map((line, index) => this.mapLine(line, index));

      return [].concat.apply([], lines);
    },
    mapLine(line, index) {
      const accountID = line[0] ? line[0].toUpperCase() : "";

      return line.slice(1, 7).map((value) => {
        const data = {
          lineNumber: index,
          accountID,
        };

        if (!value) return data;

        let number = value.replace(/[-() ]/g, "");

        if (!/^\d+$/.test(number)) {
          data.error = "Must be only digits";
          data.number = number;

          return data;
        }

        if (number.length < 10) {
          data.error = "Must be 10 digits";
          data.number = number;

          return data;
        }

        data.number = this.formatPhoneNumber(number);

        return data;
      });
    },
    formatPhoneNumber(number) {
      const value =
        number.length > 10 ? number.substring(number.length - 10) : number;

      return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    },
    handleDuplicates(numbers) {
      const valid = [];

      numbers
        .filter((n) => !n.error && n.number)
        .forEach((number, index) => {
          const duplicates = numbers.filter((n) => n.number == number.number);

          if (
            duplicates.length == 1 ||
            !valid.some((v) => v == number.number)
          ) {
            valid.push(number.number);

            return;
          }

          number.error = "Duplicate";
        });
    },
    removeDuplicates(numbers) {
      return numbers.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          numbers.findIndex((obj) => {
            return JSON.stringify(obj) === _value;
          })
        );
      });
    },
    getError(row, field) {
      if (field == "accountID") return;

      const errorField = "error" + field.substring(field.length - 1);

      return row[errorField];
    },
    cancel() {
      this.$router.push({
        name: "SMS",
      });
    },
    sendMessage() {
      if (!this.validate()) return;

      this.confirmDialog = true;
    },
    validate() {
      if (this.message && this.to.length && this.from) return true;

      this.$refs.message.validate(true);
      this.$refs.from.validate(true);

      let error;

      if (!this.to.length) {
        error = "Please upload a list of phone numbers";
      }

      if (!this.message) {
        error = "Message Required";
      }

      if (!this.from) {
        error = "From Number Required";
      }

      this.$notify({
        text: error,
        group: "notification",
        type: "error",
      });

      return false;
    },
    async checkForDuplicates(numbers) {
      try {
        const duplicates = await this.$http.post(
          "api/broadcast/checkForDuplicateMessage",
          numbers.map(this.getMessage)
        );

        this.duplicates = duplicates.messages;
        this.duplicateCount = duplicates.count;

        return duplicates;
      } catch (e) {}
    },
    async process() {
      const numbers = this.to.filter((n) => n.number && !n.error);

      const duplicates = await this.checkForDuplicates(numbers);

      if (duplicates.count > 0) {
        this.confirmDuplicatesDialog = true;

        return;
      }
      this.send();
    },
    async send() {
      const numbers = this.to.filter((n) => n.number && !n.error);

      this.sending = true;
      this.requestID = Math.floor(Math.random() * 10000000);
      this.totalProcessingMessages = numbers.map(this.getMessage).length;
      this.processingMessages = "0/" + this.totalProcessingMessages;

      try {
        await this.$http.post(
          "api/broadcast/sendMessage?requestID=" + this.requestID,
          numbers.map(this.getMessage)
        );

        this.$notify({
          text: "Messages Sent",
          group: "notification",
          type: "success",
        });

        this.totalProcessingMessages = 0;
        this.processingMessages = "";

        this.confirmDialog = false;

        this.$router.push({
          name: "SMS",
        });
      } catch (e) {
        this.totalProcessingMessages = 0;
        this.processingMessages = "";
        this.sending = false;
      } finally {
        //this.sending = false;
      }
    },
    getMessage({ number, accountID }) {
      return {
        accountId: accountID,
        from: this.from.number,
        to: "1" + number.replace(/[-() ]/g, ""),
        text: this.message,
        username: this.$store.state.authentication.user,
      };
    },
    openManualInputDialog() {
      this.manualInputDialog = true;
    },
    closeManualInputDialog() {
      this.manualInputDialog = false;
      this.manualEntry = {
        accountID: "",
        phone1: "",
        phone2: "",
        phone3: "",
        phone4: "",
        phone5: "",
        phone6: "",
      };
    },
    addManualEntry() {
      // Validate all phone fields
      const phone1Valid = this.$refs.manualPhone1.validate(true);
      const phone2Valid = this.$refs.manualPhone2.validate(true);
      const phone3Valid = this.$refs.manualPhone3.validate(true);
      const phone4Valid = this.$refs.manualPhone4.validate(true);
      const phone5Valid = this.$refs.manualPhone5.validate(true);
      const phone6Valid = this.$refs.manualPhone6.validate(true);

      if (
        !phone1Valid ||
        !phone2Valid ||
        !phone3Valid ||
        !phone4Valid ||
        !phone5Valid ||
        !phone6Valid
      ) {
        this.$notify({
          text: "Please fix validation errors",
          group: "notification",
          type: "error",
        });
        return;
      }

      // Build array of manual entries similar to file format
      const lineData = [
        this.manualEntry.accountID,
        this.manualEntry.phone1,
        this.manualEntry.phone2,
        this.manualEntry.phone3,
        this.manualEntry.phone4,
        this.manualEntry.phone5,
        this.manualEntry.phone6,
      ];

      // Get the next line number
      const lineNumber = this.toNumbers.length;

      // Map the manual entry using the same logic as file upload
      const mappedNumbers = this.mapLine(lineData, lineNumber);

      // Add to existing numbers
      const allNumbers = [...this.to, ...mappedNumbers];

      // Handle duplicates
      this.handleDuplicates(allNumbers);

      this.to = allNumbers;

      // Update display table
      const group = groupBy(allNumbers, "lineNumber");

      this.toNumbers = Object.keys(group).map((key) => {
        const numbers = group[key];

        return {
          accountID: numbers[0] ? numbers[0].accountID : "",
          phone1: numbers[0] ? numbers[0].number : "",
          phone2: numbers[1] ? numbers[1].number : "",
          phone3: numbers[2] ? numbers[2].number : "",
          phone4: numbers[3] ? numbers[3].number : "",
          phone5: numbers[4] ? numbers[4].number : "",
          phone6: numbers[5] ? numbers[5].number : "",
          error1: numbers[0] ? numbers[0].error : "",
          error2: numbers[1] ? numbers[1].error : "",
          error3: numbers[2] ? numbers[2].error : "",
          error4: numbers[3] ? numbers[3].error : "",
          error5: numbers[4] ? numbers[4].error : "",
          error6: numbers[5] ? numbers[5].error : "",
        };
      });

      this.$notify({
        text: "Phone numbers added successfully",
        group: "notification",
        type: "success",
      });

      this.closeManualInputDialog();
    },
  },
};
</script>
<style>
.number-list table.vgt-table td {
  padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.number-list table.vgt-table {
  font-size: 15px !important;
}
.number-list .vgt-responsive {
  overflow-x: unset;
}
</style>
